// Break-rule helpers: daily-required pause minutes from a worked-minutes total.
// `tiers` are sorted ascending by afterHours; we apply the highest-matching
// tier (greedy), not the sum — that's how DE ArbZG §4 reads in practice.
import type { BreakRule, BreakRuleTier } from './api'

export type { BreakRuleTier }

// Default fallback when the user hasn't picked a break rule.
// Matches DE federal ArbZG §4.
export const DEFAULT_TIERS: BreakRuleTier[] = [
  { afterHours: 6, requiredMinutes: 30 },
  { afterHours: 9, requiredMinutes: 45 },
]

export function tiersOf(rule: BreakRule | null | undefined): BreakRuleTier[] {
  return rule?.tiers ?? DEFAULT_TIERS
}

// Returns the required pause in minutes for a given amount of worked minutes.
// ArbZG §4 reads "bei einer Arbeitszeit von mehr als sechs … Stunden" — the
// threshold is strict-greater-than, so exactly 6h does NOT yet require a
// break. Tiers are interpreted the same way (workedMinutes > afterHours*60).
// E.g. DE: ≤ 6h → 0, > 6h … ≤ 9h → 30, > 9h → 45.
export function requiredBreakMinutes(workedMinutes: number, tiers: BreakRuleTier[]): number {
  let req = 0
  const sorted = [...tiers].sort((a, b) => a.afterHours - b.afterHours)
  for (const t of sorted) {
    if (workedMinutes > t.afterHours * 60) req = t.requiredMinutes
  }
  return req
}
